import { defineStore } from 'pinia';
import loteModel from '@/models/loteModel';
import pujaModel from '@/models/pujaModel';
import subastaModel from '@/models/subastaModel';
import { useUsuarioStore } from '@/store/usuarioStore';
import { reactive } from 'vue';

export const useLoteStore = defineStore('LoteStore', {
    state: () => ({
        lote: { ...loteModel.data },
        puja: { ...pujaModel.data },
        cargos: {
            precio: 0,
            porcentaje_uso_de_plataforma: 10,
            porcentaje_gastos_administrativos: 3,
            uso_de_plataforma: 0,
            gastos_administrativos: 0,
            total_cargos: 0,
        },
        panelOferta: reactive({
            n: 0,
            nueva_oferta: 0,
        }),
        aceptoTerminos: null,
        loadingPuja: false,
    }),

    actions: {
        async obtenerLote(id = this.lote.id) {
            try {
                const lote = await loteModel.obtenerLote(id);
                Object.assign(this.lote, lote);
            } catch (error) {
                console.error("Error en el store al obtener el lote:", error);
            }
        },

        async obtenerPuja(subasta_id = this.lote.subasta_id, id = this.lote.id) {
            try {
                this.loadingPuja = true;
                const params = {
                    subasta_id: subasta_id,
                    lote_id: id,
                    order: "asc",
                };

                const puja = await pujaModel.obtenerPuja(params);
                Object.assign(this.puja, puja);
                this.inicializarPanel();
                this.calcularCargos()
            } catch (error) {
                console.error("Error en el store al obtener la puja:", error);
            } finally {
                this.loadingPuja = false;
            }
        },

        async obtenerActualizada(subasta_id = this.lote.subasta_id, id = this.lote.id) {
            try {
                const params = {
                    subasta_id: subasta_id,
                    lote_id: id,
                    order: "asc",
                };

                const puja = await pujaModel.obtenerPuja(params);
                this.calcularCargos();
                Object.assign(this.puja, puja);

            } catch (error) {
                console.error("Error en el store al obtener la puja:", error);
            }
        },

        async actualizacionOferta(){          
                let puja = await this.obtenerActualizada();
                Object.assign(this.puja, puja);
                if (this.panelOferta.nueva_oferta <= this.puja.oferta_actual) {
                    this.panelOferta.n = 0;
                    this.panelOferta.nueva_oferta = this.puja.oferta_actual;
                }
                await new Promise(r => setTimeout(r, 5000));
        },

        async calcularCargos() {

            
            this.cargos.porcentaje_uso_de_plataforma = this.lote?.subasta?.uso_de_plataforma ?? 10;
            this.cargos.porcentaje_gastos_administrativos = this.lote?.subasta?.gastos_administrativos ?? 3;

            this.cargos.precio = this.puja?.oferta_actual ?? this.lote?.precio_inicial ?? 0;
            this.cargos.uso_de_plataforma = this.cargos.precio* (this.cargos.porcentaje_uso_de_plataforma / 100);
            this.cargos.gastos_administrativos = this.cargos.precio * (this.cargos.porcentaje_gastos_administrativos / 100);
            this.cargos.total_cargos = this.cargos.precio + this.cargos.uso_de_plataforma + this.cargos.gastos_administrativos;
        },

        inicializarPanel() {
            const ofertaActual = this.puja.oferta_actual || 0;

            this.panelOferta.n = 0; 
            this.panelOferta.nueva_oferta = ofertaActual;
        },


        incrementarOferta() {
            if (this.panelOferta.nueva_oferta < this.puja.oferta_actual) {
                // Si la nueva oferta está por debajo, la igualamos a la oferta actual
                this.panelOferta.nueva_oferta = this.puja.oferta_actual;
            } 
        
            // Una vez que ya es igual o mayor, siempre permite sumar más
            if (this.panelOferta.nueva_oferta >= this.puja.oferta_actual) {
                this.panelOferta.n += 1;
                this.panelOferta.nueva_oferta += this.puja.incremento;
            }
        },

        decrementarOferta() {
            if (this.panelOferta.n > 1) {
                this.panelOferta.n -= 1;
                this.panelOferta.nueva_oferta -= this.puja.incremento;
            }
        },

        async ofertar() {
            const params = {
                n: this.panelOferta.n,
                incremento: this.puja.incremento,
                nueva_oferta: this.panelOferta.nueva_oferta,
                puja_id: this.puja.id,
            };

            try {
                await pujaModel.ofertar(params);
                await this.obtenerPuja();
                const usuarioStore = useUsuarioStore();
                await usuarioStore.refrescarResumenGarantiasUsuario();
            } catch (error) {
                console.error("Error al ofertar:", error);
                throw error;
            }
        },


        async obtenerAceptoTerminos(subasta_id){
            try {
                const aceptoTerminos = await subastaModel.obtenerAceptoTerminos(subasta_id);
                this.aceptoTerminos = aceptoTerminos.aceptado;
            } catch (error) {
                console.error("Error en el store al si acepto los términos y cóndiciones:", error);
            }
        },

        async aceptarTerminosCondiciones(subasta_id){
            try {
                const aceptoTerminos = await subastaModel.aceptarTerminosCondiciones(subasta_id);
                this.aceptoTerminos = aceptoTerminos;
            } catch (error) {
                console.error("Error en el store al si acepto los términos y cóndiciones:", error);
            }
        }

    },
});